enum ConversationType {
    Customer = 1,
    Supplier = 2,
    Internal = 3,
}

export default ConversationType;
